module.exports = __webpack_public_path__ + "media/2x/users-by-device@2x-8d3a8fb8.png";